import React from 'react';
import styles from './AdvancedNoFilterOptions.module.scss';


const AdvancedNoFilterOptions = () => {


  return (
    <div className = {styles.div}>
      <label className = {styles.label}>Not available</label>
    </div>
  );
}

export default AdvancedNoFilterOptions;
